// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"db0420fe","322":"2a40ce85","447":"fc6190c1"}[chunkId] + ".chunk.css";
};